import styled from 'styled-components';

import type {StyledProps} from './types';

import {web} from './styles';

export const Text = styled.span.attrs<StyledProps>(
  ({testID, variant = 'body'}) => ({
    'data-test-id': testID,
    variant,
  }),
)<StyledProps>`
  ${web};
`;
